import NsTable from '@britishgasenergy/react-nucleus/dist/nuc-components/NsTable';
import NsSkeleton from '@britishgasenergy/react-nucleus/dist/nuc-components/NsSkeleton';

export const testId = 'tariffTableSkeletonTestId';

export const TariffTableSkeleton = () => {
  const products = [1, 2, 3];

  return (
    <NsTable>
      <table data-testid={testId}>
        <thead>
          <tr>
            {products.map((index) => (
              <th key={index}>
                <h6 slot="heading">
                  <NsSkeleton />
                </h6>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            {products.map((index) => (
              <td key={index}>
                <p>
                  <NsSkeleton type="text" />
                </p>
                <h5 slot="heading">
                  <NsSkeleton />
                </h5>
                <h5 slot="heading">
                  <NsSkeleton />
                </h5>
              </td>
            ))}
          </tr>

          <tr>
            {products.map((index) => (
              <td key={index}>
                <p>
                  <NsSkeleton type="text" />
                </p>
                <h6 slot="subheading">
                  <NsSkeleton />
                </h6>
                <h5 slot="heading">
                  <NsSkeleton />
                </h5>
                <h5 slot="heading">
                  <NsSkeleton />
                </h5>
              </td>
            ))}
          </tr>

          <tr>
            {products.map((index) => (
              <td key={index}>
                <p>
                  <NsSkeleton type="text" />
                </p>
                <h6 slot="subheading">
                  <NsSkeleton />
                </h6>
                <h5 slot="heading">
                  <NsSkeleton />
                </h5>
                <h5 slot="heading">
                  <NsSkeleton />
                </h5>
              </td>
            ))}
          </tr>

          <tr>
            {products.map((index) => (
              <td key={index}>
                <p>
                  <NsSkeleton type="text" />
                </p>
                <h6 slot="subheading">
                  <NsSkeleton />
                </h6>
                <h5 slot="heading">
                  <NsSkeleton />
                </h5>
                <h5 slot="heading">
                  <NsSkeleton />
                </h5>
              </td>
            ))}
          </tr>

          <tr>
            {products.map((index) => (
              <td key={index}>
                <h4 slot="heading">
                  <NsSkeleton type="text" />
                </h4>
                <h5 slot="subheading">
                  <NsSkeleton />
                </h5>
              </td>
            ))}
          </tr>

          <tr>
            {products.map((index) => (
              <td key={index}>
                <h5 slot="heading">
                  <NsSkeleton />
                </h5>
                <p>
                  <NsSkeleton type="text" />
                </p>
              </td>
            ))}
          </tr>

          <tr>
            {products.map((index) => (
              <td key={index}>
                <p>
                  <NsSkeleton />
                </p>
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </NsTable>
  );
};
